import React, { useEffect, useRef } from "react";

const AnotherComponent = () => {
  const titleRef = useRef(null);
  const paraRef = useRef(null);
  const datadetailRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            // Remove class when element goes out of view so it re-triggers on scroll again
            entry.target.classList.remove("visible");
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -100px 0px",
      }
    );

    const elements = [
      titleRef.current,
      paraRef.current,
      datadetailRef.current,
      imgRef.current,
    ];
    elements.forEach((el) => el && observer.observe(el));

    return () => {
      elements.forEach((el) => el && observer.unobserve(el));
    };
  }, []);

  return (
    <div id="about" className="container aboutBg next-section">
      <div className="row">
        <div
          ref={titleRef}
          className="title_line text-center p-5 animate-title"
        >
          Who We Are
        </div>
        <div className="col-md-7 order-2 order-md-1 about_data">
          <div ref={datadetailRef} className="info_big animate-para">
            Path Breaking Solutions For
            <span> Your Business</span>
          </div>
          <p ref={paraRef} className="pt-1 pb-1 animate-para">
            Founded in 2025, TechnoServe is proud to stand among the leading IT
            & business consulting companies in the world. We put customers first
            and are driven by outcomes. Our goal is simple: to help you grow
            with confidence, innovate with purpose, and make a lasting impact.
            <br /> <br />
            While you understand your business well, we bring deep tech insight
            and use it to solve your challenges with clarity and efficiency.
          </p>
        </div>
        <div className="col-md-5  order-1 order-md-2">
          <img
            ref={imgRef}
            src="/about_image.png"
            className="animate-title img-fluid"
            alt="About"
          />
        </div>
      </div>
    </div>
  );
};

export default AnotherComponent;
